/**
 * @ Description: file content
 * @ Author: ywl
 * @ Create Time: 2021-03-05 14:33:09
 * @ Modified by: cmx
 * @ Modified time: 2025-05-20 18:11:17
 */
import Vue from "vue";
import userApis from "./modules/user";
import personApis from "./modules/person";
import articleApis from "./modules/article";
import templateApis from "./modules/template";
import memberApis from "./modules/member";
import messageApis from "./modules/message";
import questionApis from "./modules/question";
import taskApis from "./modules/task";
import mutualApis from "./modules/mutual";
import contact from "./modules/contact";
import merchant from "./modules/merchant";
import ai from "./modules/ai";
const apis: IApis = {
  ...userApis,
  ...personApis,
  ...articleApis,
  ...templateApis,
  ...memberApis,
  ...messageApis,
  ...questionApis,
  ...taskApis,
  ...mutualApis,
  ...contact,
  ...merchant,
  ...ai,
};

Vue.prototype.$apis = apis;

/**
 * @description: 定义apis的接口
 */
export interface IApis {
  /**
   * @description: 登录api
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  login(data: any): Promise<any>;
  /**
   * @description: 注册api
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  register(data: any): Promise<any>;
  /**
   * @description: 获取用户信息api
   * @return {*} Promise
   */
  getUserInfo(): Promise<any>;
  /**
   * @description: 获取验证码api
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVerifyCode(data: any): Promise<any>;
  /**
   * @description: 重置密码api
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  resetPassword(data: any): Promise<any>;
  /**
   * @description: 获取登录二维码api
   * @return {*} Promise
   */
  getQRCode(): Promise<any>;
  /**
   * 轮询查看微信登录状态
   * @param data - 接口参数
   */
  getWxLoginStatus(data: any): Promise<any>;
  /**
   * 微信绑定
   * @param data - 接口参数
   */
  getBindingLogin(data: any): Promise<any>;
  // 统计--选手投票结果
  getStatisticsPlayerList(data: any): Promise<any>;
  // 新建or修改活动
  /**
   * @description: 活动详情
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVote(data: any): Promise<any>;
  /**
   * @description: 新增和更新活动设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateVote(data: any): Promise<any>;
  /**
   * @description: 更新单独字段活动设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateToAloneVote(data: any): Promise<any>;
  /**
   * @description: 系统轮播图
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getPageWxAppletPicture(data: any): Promise<any>;
  /**
   * @description: 选手列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getPlayerList(data: any): Promise<any>;
  /**
   * @description: 分组列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getPlayerTypeList(data: any): Promise<any>;
  /**
   * @description: 新增or保存分组
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateWxPlayerType(data: any): Promise<any>;
  /**
   * @description: 删除分组
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  delWxPlayerType(data: any): Promise<any>;
  /**
   * @description: 批量删除选手
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  delWxPlayer(data: any): Promise<any>;
  /**
   * @description: 批量选手选择分组
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getAddWxPlayerType(data: any): Promise<any>;
  /**
   * @description: 添加选手
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  addPlayer(data: any): Promise<any>;
  /**
   * @description: 活动高级设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVoteSetting(data: any): Promise<any>;
  /**
   * @description: 新增和更新高级设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateVoteSetting(data: any): Promise<any>;
  /**
   * @description: 背景音乐
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getMusicList(data: any): Promise<any>;
  /**
   * @description: 活动背景音乐
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getCommentShow(data: any): Promise<any>;
  /**
   * @description:  审核评论
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getCommentDel(data: any): Promise<any>;
  /**
   * @description:  删除评论
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getCommentList(data: any): Promise<any>;
  /**
   * @description: 评论列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getMusicByVoteId(data: any): Promise<any>;
  /**
   * @description: 获取活动在线报名表单
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getWxAppletVoteSignUp(data: any): Promise<any>;
  /**
   * @description: pc--新增/修改在线报名表单
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateSignUp(data: any): Promise<any>;
  // 活动列表
  /**
   * @description: 活动列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVoteList(data: any): Promise<any>;
  /**
   * @description: 活动暂停or开始
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVoteSuspendOrStart(data: any): Promise<any>;
  /**
   * @description: 复制活动
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getCopeVote(data: any): Promise<any>;
  /**
   * @description: 拉入回收站or拉出回收站（恢复活动）
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getDelVote(data: any): Promise<any>;
  /**
   * @description: 清空活动票数
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getClearVotes(data: any): Promise<any>;
  /**
   * @description: 文章问题列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getArticleList(data: any): Promise<any>;
  /**
   * @description: 单个文章详情
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getArticleDetail(data: any): Promise<any>;
  /**
   * @description: 获取模板
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getWxAppletTemplate(data: any): Promise<any>;
  /**
   * @description: 根据voteId获取模板信息
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getTemplateByVoteId(data: any): Promise<any>;
  /**
   * @description: 删除在线报名表单
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  delSignUp(data: any): Promise<any>;
  /**
   * @description: 保存在线报名表单
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdatePlayer(data: any): Promise<any>;
  /**
   * @description: 批量添加选手
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  batchAdd(data: any): Promise<any>;
  /**
   * @description: 更新选手编号或名称
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updatePlayerByNoOrName(data: any): Promise<any>;
  /**
   * @description: 获取活动分页模板
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getPageWxAppletTemplate(data: any): Promise<any>;
  /**
   * @description: 官网案例
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVoteCaseList(data: any): Promise<any>;
  /**
   * @description: 彻底删除
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getThoroughDelVote(data: any): Promise<any>;
  /**
   * @description: 彻底删除
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getDepotVoteList(data: any): Promise<any>;
  /**
   * @description: 官网案例详情
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getVoteCaseDetail(data: any): Promise<any>;
  /**
   * @description: 官网保存意见/建议
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateFeedBack(data: any): Promise<any>;
  /**
   * @description:保存更活动音乐
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateMusic(data: any): Promise<any>;
  /**
   * @description: 查询本地背景音乐
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getLocalMusicByVoteId(data: any): Promise<any>;
  /**
   * @description: 查询本地背景音乐
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getAppletCode(data: any): Promise<any>;
  /**
   * 修改密码
   */
  changePassword(data: any): Promise<any>;
  /**
   * 修改用户名
   */
  upDateUserName(data: any): Promise<any>;
  /**
   * 绑定公众号openid
   */
  bindingUser(data: any): Promise<any>;
  /**
   * 审核选手
   */
  getPlayerVerify(data: any): Promise<any>;
  /**
   * 会员等级列表
   */
  getMemberList(data: any): Promise<any>;
  /**
   * 创建充值订单
   */
  saveRechargeOrder(data: any): Promise<any>;
  /**
   * 支付二维码
   */
  wxTradePagePay(data: any): Promise<any>;
  /**
   * 检查订单状态
   */
  getOrderStatus(data: any): Promise<any>;
  /**
   * 消息列表
   */
  getMessageList(data: any): Promise<any>;
  /**
   * 信息数量
   */
  getListCount(data: any): Promise<any>;
  /**
   * 设置已读信息
   */
  getReadMessage(data: any): Promise<any>;
  /**
   * 设置单个已读信息
   */
  getReadSingleMessage(data: any): Promise<any>;
  /**
   * 用户充值订单
   */
  getUserRechargeList(data: any): Promise<any>;
  /**
   * 申请发票
   */
  getInvoiceSaveOrUpdate(data: any): Promise<any>;
  /**
   * 发票详情
   */
  getInvoiceInfo(data: any): Promise<any>;
  /**
   * 撤销申请发票
   */
  getRevokeInvoice(data: any): Promise<any>;
  /**
   * 删除充值订单
   */
  getRechargeDel(data: any): Promise<any>;
  /**
   * pc—选手投票记录
   */
  getVotingDetailList(data: any): Promise<any>;
  /**
   * pc—推荐模板
   */
  getVoteRecommendList(data: any): Promise<any>;
  /**
   * pc—热门文章列表
   */
  getArticleHotList(data: any): Promise<any>;
  /**
   * pc--文章无帮助+1
   */
  getArticleUseless(data: any): Promise<any>;
  /**
   * pc—文章有用+1
   */
  getArticleUseful(data: any): Promise<any>;
  /**
   * @description: 问卷列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getWxQuestionList(data: any): Promise<any>;

  /**
   * @description: 问卷调查设置详情
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getWxQuestionSetting(data: any): Promise<any>;

  /**
   * @description: 更新问卷设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updateWxQuestionSetting(data: any): Promise<any>;
  /**
   * @description: pc--保存问卷
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateWxQuestion(data: any): Promise<any>;
  /**
   * @description:  pc--选择题型
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  createSubject(data: any): Promise<any>;
  /**
   * @description: pc--问卷
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getWxQuestion(data: any): Promise<any>;
  /**
   * @description: pc--问卷题目
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getSubject(data: any): Promise<any>;
  // /**
  //  * @description:  pc--问卷调查设置详情
  //  * @param {any} data - 接口参数
  //  * @return {*} Promise
  //  */
  // getWxQuestionSetting(data: any): Promise<any>;
  /**
   * @description:  pc--题目移动
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getSubjectMoveList(data: any): Promise<any>;
  /**
   * @description: pc--题目选项移动
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getSubjectOptionMoveList(data: any): Promise<any>;
  /**
   * @description: pc--更新问卷
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updateWxQuestion(data: any): Promise<any>;
  /**
   * @description: pc--更新问卷内容
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updateWxQuestionSubject(data: any): Promise<any>;
  /**
   * @description:pc--更新题目选项
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updateSubjectOption(data: any): Promise<any>;

  /**
   * @description:pc--题目删除
   * @param data - 接口参数
   */
  getSubjectDel(data: any): Promise<any>;
  /**
   * @description: pc--题目复制
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getSubjectCopy(data: any): Promise<any>;
  /**
   * @description: pc--添加选项
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  addOption(data: any): Promise<any>;
  /**
   * @description: pc--删除选项
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  delOption(data: any): Promise<any>;
  /**
   * @description: pc--批量添加选项
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  batchAddOption(data: any): Promise<any>;
  /**
   * @description: pc--批量添加图片选项
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  picPatchAddOption(data: any): Promise<any>;
  /**
   * @description: pc--导入选项--级联题导入数据
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getImpOption(data: any): Promise<any>;
  /**
   * @description: pc--量表题分值说明列表
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getOptionGaugeList(data: any): Promise<any>;
  /**
   * @description: pc--更新选项--分值说明
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  updateOptionGauge(data: any): Promise<any>;
  /**
   * @description: pc--保存标签设置
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  saveOrUpdateGaugeLabel(data: any): Promise<any>;
  /**
   * @description: pc--级联数据
   * @param {any} data - 接口参数
   * @return {*} Promise
   */
  getCascadeList(data: any): Promise<any>;

  getMatrixOptionMoveList(data: any): Promise<any>;
  updateSubjectOptionMatrix(data: any): Promise<any>;
  addOptionMatrix(data: any): Promise<any>;
  batchAddOptionMatrix(data: any): Promise<any>;
  delOptionMatrix(data: any): Promise<any>;
  getWxQuestionDel(data: any): Promise<any>;
  getWxQuestionDelList(data: any): Promise<any>;
  getRetrieveWxQuestion(data: any): Promise<any>;
  getWxQuestionCompletelyDel(data: any): Promise<any>;
  saveOrUpdateFormat(data: any): Promise<any>;
  getArticleCount(data: any): Promise<any>;
  getQuestionStatement(data: any): Promise<any>;
  getQuestionStatementType(data: any): Promise<any>;
  getQuestionStatementTypePage(data: any): Promise<any>;
  getQuestionStatementTypeByCascadeLevel(data: any): Promise<any>;
  getSubjectByCascadeLevel(data: any): Promise<any>;
  getQuestionDataDetail(data: any): Promise<any>;
  getStatementSubject(data: any): Promise<any>;
  getStatementStatus(data: any): Promise<any>;
  getStatementDetail(data: any): Promise<any>;
  getQuestionStatus(data: any): Promise<any>;
  getSubjectList(data: any): Promise<any>;
  getLogicList(data: any): Promise<any>;
  saveOrUpdateWxQuestionLogic(data: any): Promise<any>;
  delLogicJump(data: any): Promise<any>;
  delLogic(data: any): Promise<any>;
  getQuestionCopy(data: any): Promise<any>;
  getQuestionClear(data: any): Promise<any>;
  getStatementSubjectDataDetail(data: any): Promise<any>;
  getStatementByManualScore(data: any): Promise<any>;
  getStatementByIsManual(data: any): Promise<any>;
  getQuestionCode(data: any): Promise<any>;
  getWxQuestionTemplateList(data: any): Promise<any>;
  getWxQuestionTemplateTypeList(data: any): Promise<any>;
  getExportExcelDownload(data: any): Promise<any>;
  getWxQuestionTemplateDetail(data: any): Promise<any>;
  getWxQuestionHotTemplate(data: any): Promise<any>;
  batchNameAddPlayer(data: any): Promise<any>;
  getThemeList(data: any): Promise<any>;
  getThemeHeaderList(data: any): Promise<any>;
  getThemeSetting(data: any): Promise<any>;
  getQuestionTheme(data: any): Promise<any>;
  updateThemeSetting(data: any): Promise<any>;
  uploadVideo(data: any): Promise<any>;
  uploadAudio(data: any): Promise<any>;
  getLastOrNext(data: any): Promise<any>;
  getQuestionBankTypeData(data: any): Promise<any>;
  getSubjectBankCopy(data: any): Promise<any>;
  getQuestionBankData(data: any): Promise<any>;
  getConclusion(data: any): Promise<any>;
  updateConclusionSetting(data: any): Promise<any>;
  updateConclusionComment(data: any): Promise<any>;
  addConclusionComment(data: any): Promise<any>;
  delConclusionComment(data: any): Promise<any>;
  getBankTypeSubjectData(data: any): Promise<any>;
  getArticleByTypeList(data: any): Promise<any>;
  getInfoIntro(data: any): Promise<any>;
  saveOrUpdateUserCoupon(data: any): Promise<any>;
  getUserCouponList(data: any): Promise<any>;
  getCouponList(data: any): Promise<any>;
  getCouponReceive(data: any): Promise<any>;
  getLoginInfo(data: any): Promise<any>;
  getPreAuthCode(data: any): Promise<any>;
  getAuthorizerInfo(data: any): Promise<any>;
  getAuthInfoList(data: any): Promise<any>;
  delAuthInfo(data: any): Promise<any>;
  getAuthPay(data: any): Promise<any>;
  upDateAuthPay(data: any): Promise<any>;
  getSysCoverList(data: any): Promise<any>;
  getLocalMusicByQuestionId(data: any): Promise<any>;
  getMusicByQuestionId(data: any): Promise<any>;
  saveOrUpdateMusicQuestion(data: any): Promise<any>;
  updateQuestionDetailByScore(data: any): Promise<any>;
  getQuestionScoreRank(data: any): Promise<any>;
  delScoreRank(data: any): Promise<any>;
  getScoreExcelDownload(data: any): Promise<any>;
  getRandomSubjectList(data: any): Promise<any>;
  getRandomSubjectSetting(data: any): Promise<any>;
  getSolitaireNameList(data: any): Promise<any>;
  getSolitaireNameDetail(data: any): Promise<any>;
  saveOrUpdateSolitaire(data: any): Promise<any>;
  delSolitaireName(data: any): Promise<any>;
  getTeamWorkCode(data: any): Promise<any>;
  updateWorkType(data: any): Promise<any>;
  saveOrUpdateTeamWork(data: any): Promise<any>;
  getTeamWorkList(data: any): Promise<any>;
  updateTeamWorkType(data: any): Promise<any>;
  delTeamWork(data: any): Promise<any>;
  getUserTransactionList(data: any): Promise<any>;
  getBalancePay(data: any): Promise<any>;
  getTransactionAmount(data: any): Promise<any>;
  getQQLogin(data: any): Promise<any>;
  getImportSubject(data: any): Promise<any>;
  getImportQuestion(data: any): Promise<any>;
  getLogistics(data: any): Promise<any>;
  saveOrUpdateLogistics(data: any): Promise<any>;
  saveOrUpdateSpecs(data: any): Promise<any>;
  getCommoditySpecs(data: any): Promise<any>;
  delSpecs(data: any): Promise<any>;
  delSpecsType(data: any): Promise<any>;
  getQuestionCertList(data: any): Promise<any>;
  addQuestionCert(data: any): Promise<any>;
  updateQuestionCert(data: any): Promise<any>;
  copyQuestionCert(data: any): Promise<any>;
  delQuestionCert(data: any): Promise<any>;
  getCertDetail(data: any): Promise<any>;
  getCertDetailCount(data: any): Promise<any>;
  getCertDetailList(data: any): Promise<any>;
  getSubjectByType(data: any): Promise<any>;
  getQuestionDraw(data: any): Promise<any>;
  delDrawPrize(data: any): Promise<any>;
  updateQuestionDraw(data: any): Promise<any>;
  getWinDrawPrize(data: any): Promise<any>;
  updateDetailRemark(data: any): Promise<any>;
  batchDelSubject(data: any): Promise<any>;
  getTransverseAnswerList(data: any): Promise<any>;
  updateTransverseAnswer(data: any): Promise<any>;
  getAppointSetting(data: any): Promise<any>;
  updateAppointSetting(data: any): Promise<any>;
  getAppointWeekList(data: any): Promise<any>;
  updateAppointWeek(data: any): Promise<any>;
  batchUpdateAppointWeekList(data: any): Promise<any>;
  getAppointWeekTimeList(data: any): Promise<any>;
  saveOrUpdateWeekTime(data: any): Promise<any>;
  delWeekTime(data: any): Promise<any>;
  batchUpdateWeekTimeList(data: any): Promise<any>;
  getAppointTimeList(data: any): Promise<any>;
  saveOrUpdateAppointTime(data: any): Promise<any>;
  delAppointTime(data: any): Promise<any>;
  getLastOrNextQuestionDetail(data: any): Promise<any>;
  getWinDrawPrizeToVerify(data: any): Promise<any>;
  getMadeScoreExcelDownload(data: any): Promise<any>;
  downloadWinDrawPrize(data: any): Promise<any>;
  delWinDrawPrize(data: any): Promise<any>;
  saveRedPackSetting(data: any): Promise<any>;
  getRedPackSettingList(data: any): Promise<any>;
  upDateProbability(data: any): Promise<any>;
  upDateDrawTime(data: any): Promise<any>;
  wxPay(data: any): Promise<any>;
  getWxPayStatus(data: any): Promise<any>;
  getBalancePayPack(data: any): Promise<any>;
  delRedPackSetting(data: any): Promise<any>;
  cancelRedPackSetting(data: any): Promise<any>;
  getRedParkByWinDraw(data: any): Promise<any>;
  getRedParkByExamine(data: any): Promise<any>;
  getExamineList(data: any): Promise<any>;
  getVotePraise(data: any): Promise<any>;
  getVotePraise(data: any): Promise<any>;
  getArticleByTitleList(data: any): Promise<any>;
  getCollectionWhether(data: any): Promise<any>;
  getCollectionList(data: any): Promise<any>;
  getCollectionPage(data: any): Promise<any>;
  getCollectionCancel(data: any): Promise<any>;
  getCollectionSetting(data: any): Promise<any>;
  getArticleByReadList(data: any): Promise<any>;
  getRecommendedCaseList(data: any): Promise<any>;
  saveOrderAccount(data: any): Promise<any>;
  addConclusionSubject(data: any): Promise<any>;
  delConclusionSubject(data: any): Promise<any>;
  updateConclusionSubject(data: any): Promise<any>;
  getWhiteSetting(data: any): Promise<any>;
  getWhiteList(data: any): Promise<any>;
  getWhitePage(data: any): Promise<any>;
  batchAddWhite(data: any): Promise<any>;
  batchDelWhite(data: any): Promise<any>;
  updateWhiteSetting(data: any): Promise<any>;
  upDateEntry(data: any): Promise<any>;
  getEntryList(data: any): Promise<any>;
  getAdvertPay(data: any): Promise<any>;
  getQuestionCount(data: any): Promise<any>;
  getSubjectCount(data: any): Promise<any>;
  getSubjectTypeSettingList(data: any): Promise<any>;
  addSubjectTypeSetting(data: any): Promise<any>;
  delSubjectTypeSetting(data: any): Promise<any>;
  updateSubjectTypeSetting(data: any): Promise<any>;
  batchUpdateSubjectRequired(data: any): Promise<any>;
  getDownloadPdf(data: any): Promise<any>;
  getDownloadPdfZip(data: any): Promise<any>;
  getPdfName(data: any): Promise<any>;
  getDownloadList(data: any): Promise<any>;
  delDownload(data: any): Promise<any>;
  downloadWorldFile(data: any): Promise<any>;
  getScoreDetail(data: any): Promise<any>;
  getScoreGradeList(data: any): Promise<any>;
  addScoreGrade(data: any): Promise<any>;
  delScoreGrade(data: any): Promise<any>;
  upDateScoreGrade(data: any): Promise<any>;
  getScoreChart(data: any): Promise<any>;
  getSubjectAccuracy(data: any): Promise<any>;
  getTradeDetail(data: any): Promise<any>;
  getTradeExam(data: any): Promise<any>;
  getGradeChart(data: any): Promise<any>;
  getWxQuestionAuthList(data: any): Promise<any>;
  saveOrUpdateAuth(data: any): Promise<any>;
  delAuth(data: any): Promise<any>;
  getStockTypePage(data: any): Promise<any>;
  getStockTypeList(data: any): Promise<any>;
  addStockType(data: any): Promise<any>;
  updateStockTypeName(data: any): Promise<any>;
  delStockType(data: any): Promise<any>;
  getStockList(data: any): Promise<any>;
  addStock(data: any): Promise<any>;
  delStock(data: any): Promise<any>;
  batchDelStock(data: any): Promise<any>;
  getSubjectDisruptList(data: any): Promise<any>;
  getSubjectDisruptSetting(data: any): Promise<any>;
  randomGetRandomSubjectList(data: any): Promise<any>;
  addRandomSubject(data: any): Promise<any>;
  upDateRandomSubject(data: any): Promise<any>;
  getAnswerDetailByEvaluateList(data: any): Promise<any>;
  getWriteList(data: any): Promise<any>;
  getWxAppletTaskList(data: any): Promise<any>;
  getWxAppletTaskDetailList(data: any): Promise<any>;
  completeTask(data: any): Promise<any>;
  receiveTaskReward(data: any): Promise<any>;
  bindingTask(data: any): Promise<any>;
  getUserCoin(data: any): Promise<any>;
  saveTaskQuestion(data: any): Promise<any>;
  getSpaceList(data: any): Promise<any>;
  getWriteDetailList(data: any): Promise<any>;
  getWxAppletGiftPage(data: any): Promise<any>;
  getGiftExchange(data: any): Promise<any>;
  getGiftExchangePage(data: any): Promise<any>;
  getAreaList(data: any): Promise<any>;
  updateGiftAddress(data: any): Promise<any>;
  getParticipationSpacePage(data: any): Promise<any>;
  getReleaseQuestionPage(data: any): Promise<any>;
  getBalancePayCoin(data: any): Promise<any>;
  getThoroughDelVoteList(data: any): Promise<any>;
  getThoroughDelQuestionList(data: any): Promise<any>;
  findCompletelyDel(data: any): Promise<any>;
  getHotTemplateSearchPage(data: any): Promise<any>;
  getInviteQRCode(data: any): Promise<any>;
  getSpaceRelease(data: any): Promise<any>;
  getSpaceExit(data: any): Promise<any>;
  getAppointmentList(data: any): Promise<any>;
  getQuestionAnswerStatement(data: any): Promise<any>;
  getSubjectStatement(data: any): Promise<any>;
  cancelAppointStatus(data: any): Promise<any>;
  getAppointDownload(data: any): Promise<any>;
  getSolitaireSubject(data: any): Promise<any>;
  getSolitaireAnswerStatement(data: any): Promise<any>;
  getSolitaireDownload(data: any): Promise<any>;
  getSendGood(data: any): Promise<any>;
  getSolitaireOrderDetail(data: any): Promise<any>;
  updateQuestionAnswer(data: any): Promise<any>;
  bindingPhone(data: any): Promise<any>;
  getWhiteSettingVote(data: any): Promise<any>;
  getWhiteListVote(data: any): Promise<any>;
  batchAddWhiteVote(data: any): Promise<any>;
  batchDelWhiteVote(data: any): Promise<any>;
  updateWhiteSettingVote(data: any): Promise<any>;
  batchDelWinDrawPrize(data: any): Promise<any>;
  saveQuestionCopyOrSearch(data: any): Promise<any>;
  wxTradePay(data: any): Promise<any>;
  getOrderState(data: any): Promise<any>;
  aliTradePay(data: any): Promise<any>;
  alipayNotify(data: any): Promise<any>;
  updateHeadInfo(data: any): Promise<any>;
  batchModifyScore(data: any): Promise<any>;
  getScantronSubjectList(data: any): Promise<any>;
  getUserSignTask(data: any): Promise<any>;
  receiveSignTask(data: any): Promise<any>;
  getUserCoinDrawDetailPage(data: any): Promise<any>;
  getUseDrawDetail(data: any): Promise<any>;
  getUserDrawCount(data: any): Promise<any>;
  getDrawList(data: any): Promise<any>;
  getUserDraw(data: any): Promise<any>;
  getQuotaSettingList(data: any): Promise<any>;
  saveQuotaSetting(data: any): Promise<any>;
  updateQuotaName(data: any): Promise<any>;
  delQuotaSetting(data: any): Promise<any>;
  getQuotaOptionList(data: any): Promise<any>;
  getQuotaSubjectList(data: any): Promise<any>;
  saveOrUpdateQuotaOption(data: any): Promise<any>;
  updateQuotaQuantity(data: any): Promise<any>;
  delQuotaOption(data: any): Promise<any>;
  getQuotaStatement(data: any): Promise<any>;
  getVotingDetailValid(data: any): Promise<any>;
  getQuestionScoreRankByToday(data: any): Promise<any>;
  getHighestScoreRank(data: any): Promise<any>;
  getHighestScoreDownload(data: any): Promise<any>;
  getRiskControlPay(data: any): Promise<any>;
  getDownloadRedParkByWinDraw(data: any): Promise<any>;
  getVoteAuthInfo(data: any): Promise<any>;
  getVoteAuthInfoList(data: any): Promise<any>;
  getMessageReceiptPage(data: any): Promise<any>;
  saveOrUpdateMessageReceipt(data: any): Promise<any>;
  getMessageReceiptDetail(data: any): Promise<any>;
  updateSendStatus(data: any): Promise<any>;
  delMessageReceipt(data: any): Promise<any>;
  getMessageSendRecordPage(data: any): Promise<any>;
  getMessageSendRecordDetail(data: any): Promise<any>;
  getAgainSendMessage(data: any): Promise<any>;
  imageUploadApi(data: any): Promise<any>;
  getVotingDetailDownload(data: any): Promise<any>;
  getRedParkDownload(data: any): Promise<any>;
  getStatisticsPlayerDownload(data: any): Promise<any>;
  getDataSubjectList(data: any): Promise<any>;
  getDataDetail(data: any): Promise<any>;
  getContactGroupTotal(data: any): Promise<any>;
  saveOrUpdateContactGroup(data: any): Promise<any>;
  delContactGroup(data: any): Promise<any>;
  getContactGroupNameList(data: any): Promise<any>;
  saveOrUpdateContact(data: any): Promise<any>;
  getContactList(data: any): Promise<any>;
  getFieldNameList(data: any): Promise<any>;
  getShowFieldList(data: any): Promise<any>;
  saveCustomField(data: any): Promise<any>;
  getCustomFieldList(data: any): Promise<any>;
  saveOrUpdateFieldList(data: any): Promise<any>;
  getResetField(data: any): Promise<any>;
  getDefaultField(data: any): Promise<any>;
  getImportContact(data: any): Promise<any>;
  delContact(data: any): Promise<any>;
  updateUserSmsSign(data: any): Promise<any>;
  saveSysMessageReceipt(data: any): Promise<any>;
  getSysReceiptList(data: any): Promise<any>;
  getSysSmsDetail(data: any): Promise<any>;
  getAgainMessageSms(data: any): Promise<any>;
  addSmsDetail(data: any): Promise<any>;
  delSmsDetail(data: any): Promise<any>;
  getAgainSms(data: any): Promise<any>;
  addContactByGroup(data: any): Promise<any>;
  getSmsSignName(data: any): Promise<any>;
  saveOrUpdateSmsSign(data: any): Promise<any>;
  getSmsSignStatus(data: any): Promise<any>;
  getProviderStatus(data: any): Promise<any>;
  getProviderDetail(data: any): Promise<any>;
  getProviderCount(data: any): Promise<any>;
  applyMch(data: any): Promise<any>;
  getApplyDetail(data: any): Promise<any>;
  getOutRequestNo(data: any): Promise<any>;
  getAllZipFile(data: any): Promise<any>;
  getAllZipFileBySubjectName(data: any): Promise<any>;
  getOrderMonthAmount(data: any): Promise<any>;
  getContactReceiptStatus(data: any): Promise<any>;
  getAppletUrl(data: any): Promise<any>;
  getGifCount(data: any): Promise<any>;
  getWhitePageVote(data: any): Promise<any>;
  getBankPage(data: any): Promise<any>;
  getBranches(data: any): Promise<any>;
  getProviderCityList(data: any): Promise<any>;
  getAllVotingDownload(data: any): Promise<any>;
  getPlayerFileDownload(data: any): Promise<any>;
  // chatHello(data: any): Promise<any>;
  // chatExamInit(data: any): Promise<any>;
  // chatgetQuestionType(data: any): Promise<any>;
  updateQuestionTop(data: any): Promise<any>;
  // chatgenerate(data: any): Promise<any>;
  updateAiCoin(data: any): Promise<any>;
  getBalancePayAiCoin(data: any): Promise<any>;
  // worldFileAnalyze(data: any): Promise<any>;
  aiGenerateSSE(data: any): Promise<any>;
  aiExamTypeSSE(data: any): Promise<any>;
}
